/* eslint-disable react-hooks/exhaustive-deps */

import React, { useContext, useEffect, useState } from 'react';
import { SELECT_PRIORITY } from 'common/constants/cap-table/capTable';
import { CustomSelect } from 'components';
import FeaturedSpreadsheetContext from 'components/FeaturedSpreadsheet/context/FeaturedSpreadsheetContext';
import withRequired from 'components/WithRequired';
import withTooltip from 'components/WithTooltip';
import { CellValue } from 'models/interfaces/spreadsheet-types/core-types';
import { LiquidationPriorityProps } from './LiquidationPriority.props';

const LiquidationPriority = ({ cell, options, ...restProps }: LiquidationPriorityProps) => {
  const { onCommit, onRevert } = restProps;
  const { cells, onCellsChanged } = useContext(FeaturedSpreadsheetContext);
  const [selectedValue, setSelectedValue] = useState<CellValue | boolean>(false);

  // On first load set the cell value
  useEffect(() => {
    if (cell.value && !selectedValue) {
      setSelectedValue(cell.value);
    }
  }, []);

  useEffect(() => {
    if (selectedValue) {
      const tmpState = { ...cells };
      if (tmpState[cell.key!]) {
        if (tmpState[cell.key!].value !== selectedValue) {
          tmpState[cell.key!].value = selectedValue as CellValue;
          onCellsChanged([{ cell, value: selectedValue }]);
        }
      }
    }
  }, [selectedValue]);

  const handleChange = (value: CellValue) => {
    const newValue = value;
    setSelectedValue(newValue);
  };

  return (
    <CustomSelect
      id={`liquidation-priority-${cell.key}`}
      value={(selectedValue ?? '') as string}
      options={options}
      onChange={handleChange}
      onCommit={onCommit}
      onRevert={onRevert}
      disabled={cell.readOnly}
      onEmptyValue={SELECT_PRIORITY}
    />
  );
};

export default withRequired(withTooltip(LiquidationPriority));
